import { createContext, useContext, useEffect, useState } from 'react'

import { API } from '@/api'
import { ServerDomainInfo } from '@/api/type-server'

interface DomainContextType {
  domainInfos: ServerDomainInfo[]
  loading: boolean
}

const DomainContext = createContext<DomainContextType>({
  domainInfos: [],
  loading: true,
})

export function DomainProvider({ children }: { children: React.ReactNode }) {
  const [domainInfos, setDomainInfos] = useState<ServerDomainInfo[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await API.getDomainList()
        if (res.code === 0) {
          setDomainInfos(res.domainInfos)
        }
      } catch (error) {
        console.error('Failed to fetch domains:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDomains()
  }, [])

  return (
    <DomainContext.Provider value={{ domainInfos, loading }}>{children}</DomainContext.Provider>
  )
}

export const useDomain = () => useContext(DomainContext)
